import styled from '@emotion/styled';

export const StyledSkeletonListLineImage = styled.div(() => ({
    aspectRatio: '1',
    width: '100%',
    maxWidth: '150px',
}));
